import { SelectedPortfolioInfo } from '../types';
import { ReportType } from '../../../../types/generatedTypes';

export interface FilenameVariable {
  value: string;
  label: string;
  description: string;
}

export const FILENAME_VARIABLES: FilenameVariable[] = [
  {
    value: '{portfolio_name}',
    label: 'Portfolio Name',
    description: 'Client name (applied to each file if multiple)',
  },
  {
    value: '{report_type}',
    label: 'Report Type',
    description: 'Type of report',
  },
  {
    value: '{from_date}',
    label: 'From Date',
    description: 'Start date (DD-MMM-YYYY)',
  },
  {
    value: '{to_date}',
    label: 'To Date',
    description: 'End date (DD-MMM-YYYY)',
  },
];

export interface FilenameInputProps {
  value: string;
  onChange: (value: string) => void;
  portfolios: SelectedPortfolioInfo[];
  reportType: ReportType;
  fromDate: string | null;
  toDate: string | null;
}
